import React from 'react';
import Icon from '../../../components/AppIcon';

const FeaturesSection = () => {
  const features = [
    {
      icon: "Shield",
      title: "Complete Anonymity",
      description: "Profiles are fully anonymous until employers pay to unlock. No names, photos, or personal details visible during initial screening.",
      color: "primary"
    },
    {
      icon: "Target",
      title: "Skills-First Matching",
      description: "Advanced algorithms match candidates based on technical skills, experience, and job requirements rather than demographic factors.",
      color: "accent"
    },
    {
      icon: "Zap",
      title: "Instant Results",
      description: "Employers can search and filter thousands of candidates instantly. Job seekers get notified immediately when their profile is viewed.",
      color: "warning"
    },
    {
      icon: "DollarSign",
      title: "Pay-Per-Unlock Model",
      description: "Free for job seekers, affordable for employers. Only pay 149 NOK when you find a candidate worth contacting.",
      color: "success"
    },
    {
      icon: "Globe",
      title: "GDPR Compliant",
      description: "Full compliance with European privacy laws. Complete control over your data with the ability to delete your profile anytime.",
      color: "secondary"
    },
    {
      icon: "Users",
      title: "Diversity & Inclusion",
      description: "Eliminate unconscious bias in hiring. Focus on qualifications and potential, creating more diverse and inclusive workplaces.",
      color: "destructive"
    }
  ];

  return (
    <section id="features" className="py-20 lg:py-32 bg-background">
      <div className="container mx-auto px-6 lg:px-8">
        <div className="text-center mb-16">
          <div className="inline-flex items-center px-4 py-2 rounded-full bg-accent/10 text-accent text-sm font-medium mb-6">
            <Icon name="Star" size={16} className="mr-2" />
            Key Features
          </div>
          
          <h2 className="text-3xl lg:text-5xl font-bold text-foreground mb-6">
            Why Choose Workfolio?
          </h2>
          
          <p className="text-xl text-muted-foreground max-w-3xl mx-auto">
            Built for the modern workforce with privacy, fairness, and efficiency at its core. 
            Experience recruitment the way it should be.
          </p>
        </div>
        
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {features?.map((feature, index) => (
            <div 
              key={index}
              className="group bg-card rounded-2xl p-8 shadow-elevation border border-border hover:shadow-elevation-lg transition-all duration-300 hover:-translate-y-1"
            >
              {/* Icon */}
              <div className={`w-14 h-14 rounded-xl bg-${feature?.color}/10 flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300`}>
                <Icon name={feature?.icon} size={28} className={`text-${feature?.color}`} />
              </div>
              
              {/* Content */}
              <h3 className="text-xl font-semibold text-foreground mb-4">
                {feature?.title}
              </h3>
              
              <p className="text-muted-foreground leading-relaxed">
                {feature?.description}
              </p>
              
              {/* Hover Gradient */}
              <div className={`absolute inset-0 rounded-2xl bg-gradient-to-br from-${feature?.color}/5 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 pointer-events-none`}></div>
            </div>
          ))}
        </div>
        
        {/* Stats Section */}
        <div className="mt-20 bg-gradient-to-r from-primary/5 via-accent/5 to-success/5 rounded-3xl p-8 lg:p-12">
          <div className="grid md:grid-cols-3 gap-8 text-center">
            <div>
              <div className="text-4xl lg:text-5xl font-bold text-primary mb-2">500+</div>
              <div className="text-muted-foreground">Companies Trust Us</div>
            </div>
            <div>
              <div className="text-4xl lg:text-5xl font-bold text-accent mb-2">2,500+</div>
              <div className="text-muted-foreground">Active Job Seekers</div>
            </div>
            <div>
              <div className="text-4xl lg:text-5xl font-bold text-success mb-2">85%</div>
              <div className="text-muted-foreground">Successful Matches</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FeaturesSection;